import { DocumentCategoryDto } from "../../interfaces/documentCategory/DocumentCategory";
import { ApiResponse } from "../../interfaces/genericResponse/GenericResponse";

export async function GetAllDocumentCategoriesAsync(
  authToken: string
): Promise<ApiResponse<DocumentCategoryDto[]>> {
  const apiUrl: string = `${process.env.REACT_APP_API_BASE_URL}/documentCategory/getall`;

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

   const result = await response.json();
   return result;
  } catch (err) {
    throw err;
  }
}
